// src/components/Notification.js
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Notification = ({ message, type = 'success', onClose }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        className={`fixed bottom-4 right-4 z-50 p-4 rounded-lg shadow-lg ${
          type === 'success' ? 'bg-green-500' : 'bg-red-500'
        } text-white`}
      >
        <div className="flex items-center space-x-2">
          <span>{message}</span>
          <button onClick={onClose} className="hover:opacity-80">
            ✕
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Notification;